import { HOST_ENV } from "./url";

const { REACT_APP_STRIPE_PRODUCTION, REACT_APP_STRIPE_STAGING } = process.env;

/**
 * `STRIPE_API_KEY`
 * @constant {string} stripeapikey
 * @default
 */
export const STRIPE_API_KEY =
  HOST_ENV === "production"
    ? REACT_APP_STRIPE_PRODUCTION
    : REACT_APP_STRIPE_STAGING;
